import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ height: '100vh' }}>
      <Result
        style={{ position: 'relative', width: '100%', top: '50%', transform: 'translate(0, -50%)' }}
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default AccessDenied;
